export const MarketingEventsPlanDepartmentsGridPluginSettings: IPluginSettings = {
    name: 'Планы по участникам маркетинговых мероприятий',
    mnemocode: 'marketing_events_planDepartments_plugin',
    permission: 'MarketingEvents',
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'idGoods',
                propertyType: 'number',
                displayName: 'ID товара',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'idDepartment',
                propertyType: 'number',
                displayName: 'ID подразделения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'guidEs',
                propertyType: 'string',
                displayName: 'GUID товара ЕС', //Уникальный идентификатор товара в ЕС
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'quantityPlanMember',
                propertyType: 'number',
                displayName: 'План участнику (упаковок)',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'bonusMember',
                propertyType: 'number',
                displayName: 'Бонус участнику',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'quantityPlanProvisor',
                propertyType: 'number',
                displayName: 'План провизору (упаковок)',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'bonusProvisor',
                propertyType: 'number',
                displayName: 'Бонус провизору',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'priceRetail',
                propertyType: 'number',
                displayName: 'Розничная цена товара',
                visibility: true,
                width: 140
            },
            {
                order: index++,
                propertyName: 'priceRef',
                propertyType: 'number',
                displayName: 'Референтная цена товара',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'quantityFactMember',
                propertyType: 'number',
                displayName: 'Фактическое кол-во упаковок товара',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'amountFactMember',
                propertyType: 'number',
                displayName: 'Фактическая сумма',
                visibility: true,
                width: 160
            },
            {
                order: index++,
                propertyName: 'idMarketingEventGlobal',
                propertyType: 'string',
                displayName: 'ID маркетингового мероприятия',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'ID',
                visibility: false,
                width: 300
            }
        ];
    })()
};